const forms = () => {
    var globalProgressValue = 0;
    var firstDate = new Date();
    
    if(firstDate.getDay() == 4){
        firstDate.setDate(firstDate.getDate() + 4);
    } else if(firstDate.getDay() == 5){
        firstDate.setDate(firstDate.getDate() + 3);
    } else {
        firstDate.setDate(firstDate.getDate() + 2);
    }
    
    // 4 weeks later
    var lastDate = new Date();   
    if(lastDate.getDay() == 4){
        lastDate.setDate(lastDate.getDate() + 28 + 4);
    } else if(lastDate.getDay() == 5){
        lastDate.setDate(lastDate.getDate() + 28 + 3);
    } else {
        lastDate.setDate(lastDate.getDate() + 28 + 2);
    }

    function setProgress(progressValue){
        globalProgressValue = progressValue;
        $('.progress-box .progress-bar').css('width', globalProgressValue+'%');
        $('.progress-box .label-progress').html(globalProgressValue +'%');
    }
    
    function updateProgress(progressValue){
        globalProgressValue = globalProgressValue + progressValue;
        $('.progress-box .progress-bar').css('width', globalProgressValue+'%');
        $('.progress-box .label-progress').html(globalProgressValue +'%');
        
        var doneCounter = $('.progress-box ul li:not(.done)').length;
        
        if (doneCounter == 0) {
            $('.btn-show-price').show();
            $('.btn-submit-form').hide();
        }
    }
    
    function removeProgress(progressValue){
        globalProgressValue = globalProgressValue - progressValue;
        //console.log(globalProgressValue);
        $('.progress-box .progress-bar').css('width', globalProgressValue+'%');
        $('.progress-box .label-progress').html(globalProgressValue +'%');
    }
    
    function prepareResults(items, data){
        var results = "";
        var vat = 0.08;
        var period = $('#period').val();
        var periodLabel = "/ 4 tygodnie";
        
        if (period <= 4){
            periodLabel = "/ cały okres";
        }
        
        var service = data.service;
        
        if (items.length > 0){
            items.forEach(function(item){
                var itemString = '';
                var avatar = '<img src="/img/front/logo_green.svg" alt="">';
                if (item.avatar != ""){
                    avatar = '<img src="'+ item.avatar +'" alt="">';
                }
                var delivery = '<img src="/img/front/form/car.svg"><span>Dostawa gratis</span>'
                if (item.priceDelivery > 0){
                    var priceDelivery = (parseFloat(item.priceDelivery) + (parseFloat(item.priceDelivery) * vat)).toFixed(2);
                    delivery = '<span>W tym koszt transportu '+ priceDelivery.replace('.', ',') +' pln</span>'
                }

                var price = (parseFloat(item.price) * 4) + parseFloat(item.priceService) + parseFloat(item.priceDelivery);
                price = (price + (price * vat)).toFixed(2);
                
                var itemName = item.name;
                
                /*
                if (service == 1) {
                    itemName = item.name.replace('Kabina', 'Wynajem kabiny z serwisem co 4 tyg.');
                }
                
                if (service == 2) {
                    itemName = item.name.replace('Kabina', 'Wynajem kabiny z serwisem co 2 tyg.');
                }
                
                if (service == 3) {
                    itemName = item.name.replace('Kabina', 'Wynajem kabiny z serwisem 1x w tyg.');
                }
                */

                itemString += '<div id="result'+ item.id +'" class="result-item" productId="'+ item.id +'" price="'+ item.price +'" priceService="'+ item.priceService +'" priceDelivery="'+ item.priceDelivery +'" priceInsurance="'+ item.priceInsurance +'" priceOther="'+ item.priceOther +'">';
                itemString += '    <div class="company">';
                itemString += avatar;            
                itemString += '        <div class="review">';
                itemString += '            <img src="/img/front/form/star.jpg">';
                itemString += '            <span>'+ item.review +'</span>';
                itemString += '        </div>';
                itemString += '        <span class="name">'+ item.company +'</span>';
                itemString += '    </div>';
                itemString += '    <div class="product">';
                itemString += '        <span class="name">'+ itemName +'</span>';
                itemString += '        <div class="options">';
                itemString += '            <span class="label">Dodatkowe opcje:</span>';
                if (item.priceInsurance > 0){
                    itemString += '            <div class="form-group insurance">';
                    itemString += '                <div class="checkbox">';
                    itemString += '                    <label>';
                    itemString += '                        <input type="checkbox" value="1" name="optionInsurance"/>';
                    itemString += '                        <span class="box"></span>';
                    itemString += '                        <span class="true-label">Ubezpieczenie <i class="icon-info" data-toggle="tooltip" data-placement="top" title="Jest to opcja przejęcia przez dostawcę ryzyka od spalenia i kradzieży. Na wynajmującym pozostaje obowiązek zgłoszenia faktu do odpowiednich organów aby nie ponosić odpowiedzialności materialnej."></i></span>';
                    itemString += '                    </label>';
                    itemString += '                </div>';
                    itemString += '            </div>';
                }
                if (item.priceOther > 0){
                    itemString += '            <div class="form-group other">';
                    itemString += '                <div class="checkbox">';
                    itemString += '                    <label>';
                    itemString += '                        <input type="checkbox" value="1" name="optionOther"/>';
                    itemString += '                        <span class="box"></span>';
                    itemString += '                        <span class="true-label">Umywalka <i class="icon-info" data-toggle="tooltip" data-placement="top" title="Umywalka do mycia rąk wraz z pojemnikiem na wodę i mydłem uzupełnianymi podczas serwisu."></i></span>';
                    itemString += '                    </label>';
                    itemString += '                </div>';
                    itemString += '            </div>';
                }
                itemString += '        </div>';
                itemString += '        <div class="count">';
                itemString += '            <span class="label">Ilość kabin: </span>';
                itemString += '            <div class="counting-box">';
                itemString += '                <input type="text" class="only-numbers" name="count" readonly value="1">';
                itemString += '                <div class="inc btn-count">';
                itemString += '                    <i class="fa fa-plus" aria-hidden="true"></i>';
                itemString += '                </div>';
                itemString += '                <div class="dec btn-count">';
                itemString += '                    <i class="fa fa-minus" aria-hidden="true"></i>';
                itemString += '                </div>';
                itemString += '            </div>';
                itemString += '        </div>';
                itemString += '    </div>';
                itemString += '    <div class="action">';
                itemString += '        <div class="price-box">';
                itemString += '            <span class="price-value">'+ price.replace('.', ',') +' pln</span> <span>'+periodLabel+'</span><br>(brutto)';
                itemString += '        </div>';
                // itemString += '        <div class="delivery-box">';
                // itemString += delivery;
                // itemString += '        </div>';
                itemString += '        <button type="submit" form="buy-form" class="btn btn--gradient btn-order-submit btn-submit-form">Zamów</button>';
                itemString += '    </div>';
                itemString += '</div>';
                
                results += itemString;
            });
                        
        } else {
            results = '<h3>Niestety, w tej chwili nie mamy oferty dla Twojej lokalizacji.</h3>';
        }
        
        return results;
    }    
    
    $('.btn-show-price').click(function(e){
        e.preventDefault();
        
        /*
        $('.label-price-box').slideDown();
        $('.label-price').css('opacity', 1);

        // samochodzik
        setTimeout(function() {
            $('.info-box').removeClass('gratis').addClass('bounceIn animated');
            $('.gratis-mobile').removeClass('gratis').find('.info-box').addClass('bounceIn animated');
        }, 1000);
                
        $('.btn-submit-form').html('Zamawiam');
        $('.btn-show-price').hide();
        $('.btn-submit-form').show();
        */
       
       
        // run search, populate results and ...
        var url = $(this).attr('base-path');
        
        $('.order-results').slideUp(function(){
            //$('.order-results-items').empty();
        });
        
        var service = $('#serviceId').val();
        var postalCode = $('input[name=locationZipCode]').val();
        var city = $('input[name=locationCity]').val();
        var widgetHash = $('input[name=widgetHash]').val();
                
        var data = {
            service: service,
            postalCode: postalCode,
            city: city,
            widgetHash: widgetHash
        };
        
        // console.log(data);

        $.ajax({
            type: 'POST',
            data: data,
            dataType: "json",
            url: url + 'ajax/searchProducts',
            success: function(response) {
                // console.log(response);
                
                var results = prepareResults(response.results, data);
                $('.order-results-items').empty().append(results);
                $('.order-results-items i[data-toggle="tooltip"]').tooltip({ trigger: 'click hover'});
                
                setTimeout(function() {
                    $('.order-results').slideDown();
                    var offset = $('.order-results').offset().top-100;

                    $('html, body').animate({
                        scrollTop: offset
                    }, 500);
                }, 500);
            },
            error: function(response) {
                
            }
        });
    });

    function updateProgressMobile(progressValue){
        $('.progress-mobile .progress-bar').css('width', progressValue+'%');
        $('.progress-mobile .label-progress').html(progressValue+'%');
    }

    /*
    setTimeout(function() {
        $('#product-full').html($('#f_name').html()).fadeIn();
    }, 500);
    */

    $("input.only-numbers").keypress(function (e) {
        if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
            return false;
        }
    });
    
    
    $(".order-results-items").keypress('input.only-numbers', function (e) {
        if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
            return false;
        }
    });
    
    /*
    $(".order-results-items .count").on('input', 'input', function () {
        console.log(this.val());
    });
    */
    
    //$('[data-toggle="datepicker"]').datepicker({
    
    $('#date-start').datepicker({        
        startDate: firstDate,
        language: 'pl-PL',
        format: 'yyyy-mm-dd',
        autoShow: false,
        inline: false,
        container: '.form-group.date-start',
        autoHide: true,
        filter: function(date, view) {
            if ((date.getDay() === 0 || date.getDay() === 6) && view === 'day') {
                return false; // Disable weekends
            }
        },
    });
    
    $('#date-start').datepicker("setDate", firstDate);
    
    var firstDateEnd = new Date();
    var lastDateEnd = new Date();
        
    var realStartDate = $('#real-start-date').val();
    var realEndDate = $('#date-end').val();
    // console.log(realStartDate);  
    
    firstDateEnd.setDate(firstDateEnd.getDate() + 7);
    lastDateEnd.setDate(lastDateEnd.getDate() + 28);
    
    var setDefaultEndDate = true;
    
    if (typeof realStartDate !== 'undefined' && realStartDate != ""){
        realStartDate = new Date(realStartDate);
        // console.log(realStartDate);
        
        firstDateEnd = new Date(realStartDate.setDate(realStartDate.getDate() + 7));
        
        if (typeof realEndDate !== 'undefined' && realEndDate != ""){
            lastDateEnd = new Date(realEndDate);
        } else {
            lastDateEnd = new Date(realStartDate.setDate(realStartDate.getDate() + 21));
        }
        
        
    }
    
    var newStartDate = $('#new-start-date').val();
    var newEndDate = $('#new-end-date').val();
    
    // prolog dates
    if (typeof newStartDate !== 'undefined' && newStartDate != ""){
        newStartDate = new Date(newStartDate);
        firstDateEnd = new Date(newStartDate);
        
        if (typeof newEndDate !== 'undefined' && newEndDate != ""){
            newEndDate = new Date(newEndDate);
            lastDateEnd = new Date(newEndDate);
        } else {
            if (typeof realEndDate !== 'undefined' && realEndDate != ""){
                lastDateEnd = new Date(realEndDate);
            } else {
                lastDateEnd = new Date(newStartDate.setDate(newStartDate.getDate() + 28));
            }
        }
        
        setDefaultEndDate = false;
    }
    
    // console.log(firstDateEnd);
    // console.log(lastDateEnd);
    
    /*
    if(firstDateEnd.getDay() == 4){
        firstDateEnd.setDate(firstDateEnd.getDate() + 4);
    } else if(firstDateEnd.getDay() == 5){
        firstDateEnd.setDate(firstDateEnd.getDate() + 3);
    } else {
        firstDateEnd.setDate(firstDateEnd.getDate() + 2);
    }
    
    if(lastDateEnd.getDay() == 4){
        lastDateEnd.setDate(lastDateEnd.getDate() + 4);
    } else if(lastDateEnd.getDay() == 5){
        lastDateEnd.setDate(lastDateEnd.getDate() + 3);
    } else {
        lastDateEnd.setDate(lastDateEnd.getDate() + 2);
    }
    */
    
    $('#date-end').datepicker({        
        startDate: firstDateEnd,
        endDate: lastDateEnd,
        language: 'pl-PL',
        format: 'yyyy-mm-dd',
        autoShow: false,
        inline: false,
        autoHide: true,
        container: '.form-group.date-end',
        filter: function(date, view) {
            var exceptionDate = false;
            
            var month = date.getMonth();
            var day = date.getDate();
            var year = date.getFullYear();
            
            var monthEnd = lastDateEnd.getMonth();
            var dayEnd = lastDateEnd.getDate();
            var yearEnd = lastDateEnd.getFullYear();
            
            if (month == monthEnd && day == dayEnd && year == yearEnd){
                exceptionDate = true;
            }
            
            if ((date.getDay() === 0 || date.getDay() === 6) && view === 'day' && !exceptionDate) {
                return false; // Disable weekends
            }
        }
    }); 
    
    if(setDefaultEndDate){
        $('#date-end').datepicker("setDate", lastDateEnd);
    }
    
    $('#btn-change-end-date').click(function(e){
        e.preventDefault();
        $('.end-date-info').slideUp();
        $('.end-date-error').slideUp();
        $('.valid-date-info').slideUp();
       
        var selectedText = $('#date-end').val();
        var selectedDate = new Date(selectedText);
        var day = selectedDate.getDay();
        
        var now = new Date();
        
        var realStartText = $('#real-start-date').val();
        var realStartDate = new Date(realStartText);

        if (selectedDate < now || selectedDate <= realStartDate) {
            $('.valid-date-info').slideDown();
            return false;
        } else {
            // saturday or sunday
            if (day == 6 || day == 0) {
                $('.valid-date-info').slideDown();
                return false;
            } else {
                var url = $(this).attr('base-path');

                var data = {
                    orderHash: $('#order-hash').val(),
                    dateEnd: $('#date-end').val()
                }

                $.ajax({
                    type: 'POST',
                    data: data,
                    dataType: "json",
                    url: url + 'ajax/updateEndDate',
                    success: function(response) {
                        // console.log(response);
                        $('.end-date-info').slideDown();
                    },
                    error: function(response) {
                        // console.log(response);
                        $('.end-date-error').slideDown();
                    }
                });
            }
        }
    });
    
    $('#period-more-details').click(function(e){
        e.preventDefault();
        
        if($('.period-details').hasClass('active')){
            $('.period-details').removeClass('active').slideUp();
        } else {
            $('.period-details').addClass('active').slideDown();
        }
    });
        
    $('#invoiceBox').click(function(){
        $('.invoice-box').toggleClass('show');

        if ($('.invoice-box').hasClass('show')) {
            $('.invoice-box').slideDown();
        } else {
            $('.invoice-box').slideUp();
            $('.invoice-box .form-group').removeClass('error');
        }
    });
    
    /*
    $('.form-back-btn').click(function(e){
        e.preventDefault();
        window.history.go(-1);
    });
    */
    
    function getReverseGeocodingData(lat, lng) {
        var latlng = new google.maps.LatLng(lat, lng);
        var geocoder = new google.maps.Geocoder();
        
        $('#location-error').slideUp();
                
        geocoder.geocode({ 'latLng': latlng }, function (results, status) {
            if (status !== google.maps.GeocoderStatus.OK) {
                console.log(status);
            }
            
            if (status == google.maps.GeocoderStatus.OK) {
                var premise = "";
                var streetAddress = "";
                var streetNumber = "";
                var zipCode = "";
                var city = "";
                var country = "";

                results[0].address_components.forEach(function(item){
                    if (item.types.indexOf("premise") != -1) {
                        premise = item.long_name;
                    }
                        
                    if (item.types.indexOf("street_number") != -1) {
                        streetNumber = item.long_name;
                    }

                    if (item.types.indexOf("route") != -1) {
                        if (item.long_name != "Unnamed Road"){
                            streetAddress = item.long_name;
                        }
                    }

                    if (item.types.indexOf("locality") != -1) {
                        city = item.long_name;
                    }

                    if (item.types.indexOf("postal_code") != -1) {
                        zipCode = item.long_name;
                    }
                    
                    if (item.types.indexOf("country") != -1) {
                        country = item.long_name;
                    }
                });
                
                if (streetAddress == "" && premise != ""){
                    if (city != ""){
                        streetAddress = city + ' ' + premise;
                    } else {
                        streetAddress = premise;
                    }
                }
                
                // var addressPopup = (results[0].formatted_address);
                var addressPopup = streetAddress + " " + streetNumber + ", " + city + ", " + country;

                if(addressPopup != ""){
                    markerPopup.setContent(addressPopup);
                    markerPopup.open(map, marker);
                }

                $('#locationStreet').val((streetAddress + " " + streetNumber).trim());
                $('#locationZipCode').val(zipCode.trim());
                $('#locationCity').val(city.trim());
                
                if($('#locationStreet').val().trim() == "" || $('#locationStreet').val().trim() == " "){
                    $('#locationStreet').closest('.form-group').addClass('error');
                } else {
                    $('#locationStreet').closest('.form-group').removeClass('error');
                }
                
                if($('#locationZipCode').val().trim() == "" || $('#locationZipCode').val().trim() == " "){
                    $('#locationZipCode').closest('.form-group').addClass('error');
                } else {
                    $('#locationZipCode').closest('.form-group').removeClass('error');
                }
                
                if($('#locationCity').val().trim() == "" || $('#locationCity').val().trim() == " "){
                    $('#locationCity').closest('.form-group').addClass('error');
                } else {
                    $('#locationCity').closest('.form-group').removeClass('error');
                }
            }
        });
    }
    
    function getLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(setPosition, showGpsError);
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
    }
    
    function setLocationByAddress(street, zipCode, city) {
        var geocoder = new google.maps.Geocoder();
        // var address = street + ", " + zipCode + " " + city;
        var address = street + ", " + zipCode + " " + city + ", Polska";
        console.log(address);
        
        geocoder.geocode({
            'address': address,
            'region': 'PL'
        }, function(results, status) {
            console.log(results);
            // console.log(status);
            
            if (results.length > 0 && status == google.maps.GeocoderStatus.OK){
                var location = results[0].geometry.location;
                var locationType = results[0].geometry.location_type;                
                
                if (locationType == "APPROXIMATE"){
                    console.log("Address not found - APPROXIMATE");

                    $('#location-error').slideDown();
                    $('#locationStreet').closest('.form-group').addClass('error');
                    $('#locationZipCode').closest('.form-group').addClass('error');
                    $('#locationCity').closest('.form-group').addClass('error');
                    $('#locationAcc').val("");
                    $('.btn-show-price').hide();
                    $('.btn-submit-form').html('Pokaż oferty').show();

                    var offset = $('#locationStreet').offset().top-100;

                    $('html, body').animate({
                        scrollTop: offset
                    }, 500);
                } else {
                    // var addressPopup = address;
                    // var addressPopup = (results[0].formatted_address);
                                                
                    var premise = "";
                    var streetAddress = "";
                    var streetNumber = "";
                    var zipCode = "";
                    var city = "";
                    var country = "";
                
                    results[0].address_components.forEach(function(item){
                        if (item.types.indexOf("premise") != -1) {
                            premise = item.long_name;
                        }

                        if (item.types.indexOf("street_number") != -1) {
                            streetNumber = item.long_name;
                        }

                        if (item.types.indexOf("route") != -1) {
                            if (item.long_name != "Unnamed Road"){
                                streetAddress = item.long_name;
                            }
                        }

                        if (item.types.indexOf("locality") != -1) {
                            city = item.long_name;
                        }

                        if (item.types.indexOf("postal_code") != -1) {
                            zipCode = item.long_name;
                        }
                        
                        if (item.types.indexOf("country") != -1) {
                            country = item.long_name;
                        }
                    });

                    if (streetAddress == "" && premise != ""){
                        if (city != ""){
                            streetAddress = city + ' ' + premise;
                        } else {
                            streetAddress = premise;
                        }
                    }
                    
                    var addressPopup = streetAddress + " " + streetNumber + ", " + city + ", " + country;

                    map.setCenter(location);
                    marker.setPosition(location);

                    if(addressPopup != ""){
                        markerPopup.setContent(addressPopup);
                        markerPopup.open(map, marker);
                    }

                    $('#gps-latitude').val(location.lat());
                    $('#gps-longitude').val(location.lng());
                    $('.map-cover').fadeOut();
                    $('#locationAcc').val("1");
                    $('.map-container').removeClass('error');
                    $('#locationAcc-error').remove();

                    if(!$('#progress-location').hasClass('done')){
                        $('#progress-location').removeClass('active').addClass('done bounceIn animated');
                        updateProgress(33);
                    }
                }
            } else {
                console.log("Address not found.");
                
                $('#location-error').slideDown();
                $('#locationStreet').closest('.form-group').addClass('error');
                $('#locationZipCode').closest('.form-group').addClass('error');
                $('#locationCity').closest('.form-group').addClass('error');
                $('#locationAcc').val("");
                $('.btn-show-price').hide();
                $('.btn-submit-form').html('Pokaż oferty').show();
        
                var offset = $('#locationStreet').offset().top-100;

                $('html, body').animate({
                    scrollTop: offset
                }, 500);
            }
        });
    }

    function setPosition(position) {
        var pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
        };

        map.setCenter(pos);
        
        var pinLoc = new google.maps.LatLng(pos.lat, pos.lng);
        marker.setPosition(pinLoc);
                        
        // console.log(pos);
        $('#gps-latitude').val(pos.lat);
        $('#gps-longitude').val(pos.lng);
        
        getReverseGeocodingData(pos.lat, pos.lng);
        $('.map-cover').fadeOut();
        $('#locationAcc').val("1");
        $('.map-container').removeClass('error');
        $('#locationAcc-error').remove();
        
        if(!$('#progress-location').hasClass('done')){
            $('#progress-location').removeClass('active').addClass('done bounceIn animated');
            updateProgress(33);
        }
    }
        
    function showGpsError(error) {
        switch(error.code) {
            case error.PERMISSION_DENIED:
                console.log("User denied the request for Geolocation.");
                alert('Aby umożliwić pobranie lokalizaji, nadaj uprawnienia GPS w opcjach twojej przeglądarki.');
                break;
            case error.POSITION_UNAVAILABLE:
                console.log("Location information is unavailable.");
                alert('Dane lokalizacji nie są dostępne.');
                break;
            case error.TIMEOUT:
                console.log("The request to get user location timed out.");
                alert('Dane lokalizacji nie są dostępne (timeout).');
                break;
            case error.UNKNOWN_ERROR:
                console.log("An unknown error occurred.");
                alert('Dane lokalizacji nie są dostępne (error).');
                break;
        }
    }
    
/*
    $('#gps-latitude').change(function(){
        console.log("change");
        
        setTimeout(function() {
            var lat = $('#gps-latitude').val();
            var lng = $('#gps-longitude').val();
        }, 500);
    });
*/
  
/*    
    $("#get-gps").click(function(e){
        e.preventDefault();
        if(!$('#progress-location').hasClass('done')){
            $('#progress-location').removeClass('active').addClass('done bounceIn animated');
            updateProgress(20);
        }
        
        $('.info-box').removeClass('gratis').addClass('bounceIn animated');
        $('.gratis-mobile').removeClass('gratis').find('.info-box').addClass('bounceIn animated');
        
        getLocation();
    });
*/

/*
    $("input[name=gps]").change(function(){
        if(!$('#progress-location').hasClass('done')){
            $('#progress-location').removeClass('active').addClass('done bounceIn animated');
            updateProgress(20);
        }
    });
*/
    
    $("#locationStreet, #locationZipCode, #locationCity").on('input', function(){
        $('#locationGps').closest('.radio-wrapper').removeClass('active');
        $('.map-cover').fadeIn();
        $('#location-error').slideUp();
        $('#locationAcc').val("");
        $('.order-results').slideUp();
        
        $('.btn-show-price').hide();
        $('.btn-submit-form').html('Pokaż oferty').show();
        
        if($('#progress-location').hasClass('done')){
            $('#progress-location').removeClass('done bounceIn animated');
            removeProgress(33);
        }
        
        if ($('#locationStreet').val() != "" && $('#locationZipCode').val() != "" && $('#locationCity').val() != "" ){
            
            // samochodzik
            /*
            $('.info-box').removeClass('gratis').addClass('bounceIn animated');
            $('.gratis-mobile').removeClass('gratis').find('.info-box').addClass('bounceIn animated');
            */
            
            /*
            if(!$('#progress-location').hasClass('done')){
                $('#progress-location').removeClass('active').addClass('done bounceIn animated');
                updateProgress(33);
            }
            */
        } else {
            /*
            if($('#progress-location').hasClass('done')){
                $('#progress-location').removeClass('done bounceIn animated');
                removeProgress(33);
            }
            */
        }
        
    });
    
    $("input[name=locationType]").click(function(){
        $('.location-box .radio-wrapper').removeClass('active');
        $(this).parents().addClass('active');

        var value = $(this).val();

        if (value == "gps") {
            /*
            $('.row.location-manual').slideUp(function(){
                $('.row.location-gps').slideDown().css('display', 'flex');
            });
            */
            
            setTimeout(function () { 
                google.maps.event.trigger(map, 'resize');
                getLocation();
            }, 500);
        }

        // unreachable now
        if (value == "manual") {
            $('.row.location-gps').slideUp(function(){
                $('.row.location-manual').slideDown().css('display', 'flex');
            });
            
            if ($('#locationStreet').val() == "" || $('#locationZipCode').val() == "" || $('#locationCity').val() == "" ){
                if($('#progress-location').hasClass('done')){
                    $('#progress-location').removeClass('done bounceIn animated');
                    removeProgress(33);
                    
                    $('.btn-show-price').hide();
                    $('.btn-submit-form').html('Pokaż oferty').show();
                    
                    $('.label-price-box').slideUp();
                    $('.label-price').css('opacity', 0);

                    // samochodzik
                    /*
                    $('.info-box').addClass('gratis').removeClass('bounceIn animated');
                    $('.gratis-mobile').addClass('gratis').find('.info-box').removeClass('bounceIn animated');
                    */
                }
            }
        }

    });
    
    $("#map-confirm").click(function(e){
        e.preventDefault();
        var error = false;
        // get location inputs
        var street = $('#locationStreet').val();
        if (street.trim() == "" || street.trim() == " ") {
            error = true;
            $('#locationStreet').closest('.form-group').addClass('error');
            
            $('#locationStreet').attr('aria-invalid', true);
            $('#locationStreet').attr('aria-describedby', 'locationStreet-error');
            if ( $( "#locationStreet-error" ).length ) {
                $('#locationStreet-error').html('Wymagane');
                $('#locationStreet-error').css('display', 'block');
            } else {
                $('#locationStreet').closest('.form-group').append('<span id="locationStreet-error" class="error show" style="">Wymagane</span>');
            }
        }
        
        var zipCode = $('#locationZipCode').val().trim();
        if (zipCode.trim() == "" || zipCode.trim() == " " || !zipCode.match(/^\d\d-\d\d\d$/)) {
            error = true;
            $('#locationZipCode').closest('.form-group').addClass('error');
            $('#locationZipCode').attr('aria-invalid', true);
            $('#locationZipCode').attr('aria-describedby', 'locationZipCode-error');
            if ( $( "#locationZipCode-error" ).length ) {
                $('#locationZipCode-error').html('Wymagane (sprawdź format xx-xxx)');
                $('#locationZipCode-error').css('display', 'block');
            } else {
                $('#locationZipCode').closest('.form-group').append('<span id="locationZipCode-error" class="error show" style="">Wymagane (sprawdź format xx-xxx)</span>');
            }
        }
        
        var city = $('#locationCity').val();
        if (city.trim() == "" || city.trim() == " ") {
            error = true;
            $('#locationCity').closest('.form-group').addClass('error');
            
            $('#locationCity').attr('aria-invalid', true);
            $('#locationCity').attr('aria-describedby', 'locationCity-error');
            if ( $( "#locationCity-error" ).length ) {
                $('#locationCity-error').html('Wymagane');
                $('#locationCity-error').css('display', 'block');
            } else {
                $('#locationCity').closest('.form-group').append('<span id="locationCity-error" class="error show" style="">Wymagane</span>');
            }
        }
        
        // get location by address
        if(!error){
            var url = $('.btn-show-price').attr('base-path');
            
            // find postal code first
            var data = {
                postalCode: zipCode.trim(),
                city: city.trim()
            };

            $.ajax({
                type: 'POST',
                data: data,
                dataType: "json",
                url: url + 'ajax/searchPostalCode',
                success: function(response) {
                    console.log(response);
                    if (response.status == true){
                        $('#locationZipCode').closest('.form-group').removeClass('error');
                        $('#locationZipCode').attr('aria-invalid', false);
                        $('#locationZipCode-error').css('display', 'none');
                        
                        $('#locationCity').closest('.form-group').removeClass('error');
                        $('#locationCity').attr('aria-invalid', false);
                        $('#locationCity-error').css('display', 'none');
                        
                        setLocationByAddress(street, zipCode, city);
                    } else {
                        $('#locationZipCode').closest('.form-group').addClass('error');
                        $('#locationZipCode').attr('aria-invalid', true);
                        $('#locationZipCode').attr('aria-describedby', 'locationZipCode-error');
                        if ( $( "#locationZipCode-error" ).length ) {
                            $('#locationZipCode-error').html('Kod nieprawidłowy dla podanego miasta, popraw kod ręcznie.');
                            $('#locationZipCode-error').css('display', 'block');
                        } else {
                            $('#locationZipCode').closest('.form-group').append('<span id="locationZipCode-error" class="error show" style="">Kod nieprawidłowy dla podanego miasta, popraw kod ręcznie.</span>');
                        }
                        var offset = $('#locationZipCode').offset().top-100;

                        $('html, body').animate({
                            scrollTop: offset
                        }, 500);
                    }
                },
                error: function(response) {
                    console.log(response);
                    $('#locationZipCode').closest('.form-group').addClass('error');
                    $('#locationZipCode').attr('aria-invalid', true);
                    $('#locationZipCode').attr('aria-describedby', 'locationZipCode-error');
                    if ( $( "#locationZipCode-error" ).length ) {
                        $('#locationZipCode-error').html('Kod nieprawidłowy dla podanego miasta, popraw kod ręcznie.');
                        $('#locationZipCode-error').css('display', 'block');
                    } else {
                        $('#locationZipCode').closest('.form-group').append('<span id="locationZipCode-error" class="error show" style="">Kod nieprawidłowy dla podanego miasta, popraw kod ręcznie.</span>');
                    }
                    
                    var offset = $('#locationZipCode').offset().top-100;
            
                    $('html, body').animate({
                        scrollTop: offset
                    }, 500);
                }
            });
            
        } else {
            var offset = $('#locationStreet').offset().top-100;
            
            $('html, body').animate({
                scrollTop: offset
            }, 500);
        }
    });

    $("input[name=service]").change(function(){
        $('.service-box .radio-wrapper').removeClass('active');
        $(this).parents().addClass('active');
        
        $('#serviceId').val($(this).val());

        if(!$('#progress-heart').hasClass('done')){
            $('#progress-heart').removeClass('active').addClass('done bounceIn animated');
            updateProgress(33);
        }
        updatePrice();
        
        $('.order-results').slideUp();
    });

    $("input[name=insurance]").change(function(){
        $('.insurance-box .radio-wrapper').removeClass('active');
        $(this).parents().addClass('active');

        if(!$('#progress-shield').hasClass('done')){
            $('#progress-shield').removeClass('active').addClass('done bounceIn animated');
            updateProgress(33);
        }
        updatePrice();
    });

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    function daysBetween( date1, date2 ) {
        //Get 1 day in milliseconds
        var one_day=1000*60*60*24;

        // Convert both dates to milliseconds
        var date1_ms = date1.getTime();
        var date2_ms = date2.getTime();

        // Calculate the difference in milliseconds
        var difference_ms = date2_ms - date1_ms;

        // Convert back to days and return
        return Math.round(difference_ms/one_day); 
    }

    function updateStartDate(){
        var startDate = $('#date-start').val();
        var endDate = $('#date-end').val();
        $('#date-start').datepicker("setEndDate", new Date(endDate));
                        
        var dateDiff = daysBetween(new Date(startDate), new Date(endDate));
                
        var period = 1;
        
        if (dateDiff > 7){
            period = Math.ceil(dateDiff / 7);
        }
        $('#period').val(period);

        //console.log(period);        
    }
    
    function updateEndDate(){
        var startDate = $('#date-start').val();
        var endDate = $('#date-end').val();
        $('#date-end').datepicker("setStartDate", new Date(startDate));
        
        if(startDate > endDate){
            endDate = startDate;
            $('#date-end').val(startDate);            
            $('#date-end').datepicker("setDate", new Date(startDate));
        }
                
        var dateDiff = daysBetween(new Date(startDate), new Date(endDate));
        //console.log(dateDiff);
        
        // var period = $('#period').val();
        var period = 1;
        
        if (dateDiff > 7){
            period = Math.ceil(dateDiff / 7);
        }
        
        $('#period').val(period);
        //console.log(period);
        
        
        /*        
        var endDate = addDays(startDate, (period * 7));
        endDate = endDate.toISOString().substring(0,10);
        
        $('#date-end').val(endDate);
                
        var endLabel = $('.nice-select span.current').html();
        
        if(endLabel.indexOf(' (') > 0){
            endLabel = endLabel.substring(0, endLabel.indexOf(' (')) + ' (do ' + endDate + ')';
        } else {
            endLabel = endLabel + ' (do ' + endDate + ')';
        }
        
        $('.nice-select span.current').html(endLabel);
        */
    }
    
    //old function
    function updatePrice(){
        // console.log('old updatePrice');
        var unitPrice = parseFloat($('#price').val());
        var service = $('input[name=service]:checked').attr('price');
        var insurance = $('input[name=insurance]:checked').attr('price');
        var period = $('#period').val();

        if(typeof service === 'undefined') {
            service = 0;
        } else {
            service = parseFloat(service);
        }
        
        if(typeof insurance === 'undefined') {
            insurance = 0;
        } else {
            insurance = parseFloat(insurance);
        }

        var price = unitPrice + service + insurance;

        var priceLabel = price.toFixed(2) + " pln";
        var periodLabel = "<span> za cały okres</span>";
        var periodLabelMobile = "za cały okres";
        
        if (period >= 4) {
            periodLabel = "<span> / 4 tygodnie</span>";
            periodLabelMobile = "4 tygodnie";
        } else {
            periodLabel = "<span> za cały okres</span>";
            periodLabelMobile = "za cały okres";
        }
        
        $('#price-service').val(service);
        $('#price-insurance').val(insurance);
        $('#price-total').val(price);
        $('.label-price-after').html(priceLabel + periodLabel);
        
        $('.submit-mobile .label-price .price').html(priceLabel);
        $('.submit-mobile .label-price .period').html(periodLabelMobile);
    }

    $("input[name=dateStart]").change(function(){
        if(!$('#progress-calendar').hasClass('done')){
            $('#progress-calendar').removeClass('active').addClass('done bounceIn animated');
            updateProgress(33);
        }
        
        //updateEndDate();
        updatePrice();
        
        $('.order-results').slideUp();
    });
    
    $("input[name=dateEnd]").change(function(){
        
        //updateStartDate();
    });
        
    $("#period").change(function(){
        updateEndDate();
        updatePrice();
    });

    $("input[name=invoiceType]").change(function(){
        $('.invoice-box .radio-wrapper').removeClass('active');
        $(this).parents().addClass('active');

        var value = $(this).val();

        if (value == "osfiz") {
            $('.row.company').slideUp(function(){
                $('.row.osfiz').slideDown().css('display', 'flex');
            });
        }

        if (value == "company") {
            $('.row.osfiz').slideUp(function(){
                $('.row.company').slideDown().css('display', 'flex');
            });
        }

    });

    $(".gratis-mobile .info-box a").click(function(e){
        e.preventDefault();
        $(".gratis-mobile").slideUp();
    });

    var buy_options = {
        beforeSubmit: function(arr, $form, options) {
            // var productId = $('#productId').val();
            // $('#submit-'+productId).html('Zamawiam ...');
            
            /*
            var locationType = $("input[name=locationType]").val();
            console.log(locationType);
            
            if (locationType == "gps"){
                var lat = $('#gps-latitude').val();
                var lng = $('#gps-longitude').val();

                getReverseGeocodingData(lat, lng);
            }
            */
        },
        success: function(responseText, statusText, xhr, $form) {
            if (responseText != "") {
                var response  = $.parseJSON(responseText);
                //console.log(response);

                if(response.message != 'OK'){
                    /*$('.btn-submit-form').html('Wyceń');*/
                } else {
                    setTimeout(function() {
                        $('.btn-submit-form').html('Wybieram');                        
                    }, 800);
                    
                    window.location.href = $($form).attr('action-next');
                }

            } else {
                /*$('.btn-submit-form').html('Wyceń');*/
            }
        },
        error: function(responseText, statusText, xhr, $form) {
            console.log(responseText);
            console.log(statusText);
            /*$('.btn-submit-form').html('Wyceń');*/
        }
    };

    $.validator.addMethod("futureDate", function (value, element) {
        var selectedText = $(element).val();
        var selectedDate = new Date(selectedText);
        var now = new Date();
        var day = selectedDate.getDay();

        if (selectedDate < now) {
            return false;
        } else {
            // saturday or sunday
            if (day == 6 || day == 0) {
                return false;
            }

            return true;
        }
    }, "Wybierz poprawną datę");

    $('#buy-form').validate({
        ignore: [],
        rules: {
            firstname: {
                required: true,
            },
            lastname: {
                required: true,
            },
            email: {
                required: true,
                email: true
            },
            phone: {
                required: true,
            },
            service: {
                required: true,
            },
            /*
            insurance: {
                required: true,
            },
            */
            dateStart: {
                required: true,
                futureDate: true
            },
            locationStreet: {
                required: false
                /*
                required: function(element) {
                    return $("#locationManual").prop('checked');
                }
                */
            },
            locationZipCode: {
                required: true
                /*
                required: function(element) {
                    return $("#locationManual").prop('checked');
                }
                */
            },
            locationCity: {
                required: true
                /*
                required: function(element) {
                    return $("#locationManual").prop('checked');
                }
                */
            },
            /*
            period: {
                required: function(element) {
                    return $(element).val() == 0;
                }
            },
            */
           locationAcc: {
                required: true
                /*
                required: function(element) {
                    return $("#locationManual").prop('checked');
                }
                */
            }
        },
        messages: {
            firstname: {
                required: "Wymagane",
            },
            lastname: {
                required: "Wymagane",
            },
            email: {
                required: "Wymagane",
                email: "Zły format e-mail"
            },
            phone: {
                required: "Wymagane",
            },
            service: {
                required: "Wymagane",
            },
            /*
            insurance: {
                required: "Wymagane",
            },
            */
            dateStart: {
                required: "Wybierz poprawną datę",
            },
            /*
            dateEnd: {
                required: "Wymagane",
            },
            */
            locationAcc: {
                required: "Wymagane",
            }
        },
        errorElement: 'span',
        focusInvalid: false,
        invalidHandler: function(form, validator) {
            if (!validator.numberOfInvalids())
                return;
            /*
            console.log(validator.errorList);
            console.log($('.form-group.error'));
            */
			
			/*
            $('.btn-show-price').hide();
            $('.btn-submit-form').html('Pokaż oferty').show();
            
            $('.label-price-box').slideUp();
            $('.label-price').css('opacity', 0);
            */

            // samochodzik
            /*
            $('.info-box').addClass('gratis').removeClass('bounceIn animated');
            $('.gratis-mobile').addClass('gratis').find('.info-box').removeClass('bounceIn animated');
            */
           
            // var offset = $('#locationStreet').closest('.form-group').offset().top-100;
            var offset = $('#locationStreet').offset().top-100;
            
            /*
            if($(validator.errorList[0].element).closest('.form-group').length > 0){
                offset = $(validator.errorList[0].element).closest('.form-group').offset().top-100;
            }
            */
            
            /*
            if ($('.form-group.error').length > 0){
                offset = $('.form-group.error').first().offset().top-100;
            } else {
                offset = $(validator.errorList[0].element).closest('.form-group').offset().top-100;
            }
            */
           
            $('html, body').animate({
                scrollTop: offset
            }, 500);
        },
        errorPlacement: function(error, element) {
            /*console.log(element[0].name);*/
            error.insertAfter(element).addClass('show');
            
            if (element[0].name == "locationStreet" || element[0].name == "locationZipCode" || element[0].name == "locationCity"){
                if($('#progress-location').hasClass('done')){
                    $('#progress-location').removeClass('done bounceIn animated');
                    removeProgress(33);
                }
            }
        },
        highlight: function(element) {
            $(element).parents('.form-group').removeClass('valid').addClass('error');
            if ($(element).attr('name') == "locationAcc"){
                $('.map-container').addClass('error');
            }
          },
        unhighlight: function(element) {
            $(element).parents('.form-group').removeClass('error').addClass('valid');
            if ($(element).attr('name') == "locationAcc"){
                $('.map-container').removeClass('error');
            }
        },
        submitHandler: function(form) {
            var doneCounter = $('.progress-box ul li:not(.done)').length;
        
            if (doneCounter > 0) {
                $('.btn-show-price').show();
                $('.btn-submit-form').hide();
                $('.progress-box ul li:not(.done)').removeClass('active').addClass('done');
                setProgress(99);
                $('.btn-show-price').trigger('click');
            } else {
                $(form).ajaxSubmit(buy_options);
            }
        }
    });

    var buy_options_2 = {
        beforeSubmit: function(arr, $form, options) {
            $('.btn-submit-form2').html('Zamawiam ...');
            
            $('#invoiceFirstname').val($('#firstname').val());
            $('#invoiceLastname').val($('#lastname').val());
            
            // to automatyczne pola z fakturowni - już ich nie ma
            /*
            $('#payment_first_name').val($('#firstname').val());
            $('#payment_last_name').val($('#lastname').val());
            $('#payment_email').val($('#email').val());
            $('#payment_phone').val($('#phone').val());
            $('#payment_post_code').val($('#deliveryZipCode').html());
            $('#payment_city').val($('#deliveryCity').html());
            $('#payment_street').val($('#deliveryStreet').html());
            $('#payment_comment').html($('#deliveryStreet').html()+', '+$('#deliveryZipCode').html()+' '+$('#deliveryCity').html() );
            
            $('#payment_generate_invoice').prop('checked', true);
            $('#payment_invoice_name').val($('#invoiceCompanyName').val());
            $('#payment_invoice_tax_no').val($('#invoiceNip').val());
            $('#payment_invoice_post_code').val($('#invoiceZipCode').val());
            $('#payment_invoice_city').val($('#invoiceCity').val());
            $('#payment_invoice_street').val($('#invoiceStreet').val());
            */
        },
        success: function(responseText, statusText, xhr, $form) {
            if (responseText != "") {
                var response  = $.parseJSON(responseText);
                // console.log(response);

                if(response.message != 'OK'){
                    $('.btn-submit-form2').html('Zamawiam i płacę');
                } else {
                    $('#order-hash').val(response.orderHash);
                    $('#new-payment-form').submit();
                    
                    /*
                    setTimeout(function() {
                        window.location.href = $($form).attr('action-next');
                    }, 500);
                    */
                }

            } else {
                $('.btn-submit-form2').html('Zamawiam i płacę');
            }
        },
        error: function(responseText, statusText, xhr, $form) {
            console.log(responseText);
            console.log(statusText);
            $('.btn-submit-form2').html('Zamawiam i płacę');
        }
    };

    jQuery.validator.addMethod("nip", function(value, element) {
        var verificator_nip = new Array(6,5,7,2,3,4,5,6,7); var nip = value.replace(/[\ \-]/gi, ''); 

        if (nip.length != 10)  {
            return false; 
        } else {
            var n = 0;

            for (var i=0; i<9; i++) {
                n += nip[i] * verificator_nip[i]; 
            }

            n %= 11;

            if (n != nip[9]) {
                return false;
            }
        }
        return true;	
    }, "Proszę o podanie prawidłowego numeru NIP");

    $('#buy-form-2').validate({
        ignore: [],
        rules: {
            firstname: {
                required: true,
            },
            lastname: {
                required: true,
            },
            email: {
                required: true,
                email: true
            },
            phone: {
                required: true,
            },
            accept1: {
                required: true,
            },
            accept2: {
                required: true,
            },
            accept3: {
                required: true,
            },
            /*
            invoiceFirstname: {
                required: function(element) {
                    return $("#invoiceTypeOsFiz").prop('checked') && $("#invoice").prop('checked');
                }
            },
            invoiceLastname: {
                required: function(element) {
                    return $("#invoiceTypeOsFiz").prop('checked') && $("#invoice").prop('checked');
                }
            },
            */
            invoiceCompanyName: {
                required: function(element) {
                    return $("#invoiceNip").val() != "" && $("#invoiceBox").prop('checked');
                }
            },
            invoiceNip: {
                nip: {
                    //depends: "#invoiceNip:filled"
                    depends: function(element) { 
                        return $("#invoiceNip").val() != "" && $("#invoiceBox").prop('checked');
                    }
                },
                //required: "#invoiceCompanyName:filled"
                required: function(element) {
                    return $("#invoiceCompanyName").val() != "" && $("#invoiceBox").prop('checked');
                }
            },
            
            invoiceStreet: {
                required: function(element) {
                    return $("#invoiceBox").prop('checked');
                }
            },
            invoiceZipCode: {
                required: function(element) {
                    return $("#invoiceBox").prop('checked');
                }
            },
            invoiceCity: {
                required: function(element) {
                    return $("#invoiceBox").prop('checked');
                }
            },
        },
        messages: {
            firstname: {
                required: "Wymagane",
            },
            lastname: {
                required: "Wymagane",
            },
            email: {
                required: "Wymagane",
                email: "Zły format e-mail"
            },
            phone: {
                required: "Wymagane",
            },
            accept1: {
                required: "Wymagane",
            },
            accept2: {
                required: "Wymagane",
            },
            accept3: {
                required: "Wymagane",
            },
            invoiceFirstname: {
                required: "Wymagane",
            },
            invoiceLastname: {
                required: "Wymagane",
            },
            invoiceCompanyName: {
                required: "Wymagane",
            },
            invoiceNip: {
                required: "Wymagane",
            },
            invoiceStreet: {
                required: "Wymagane",
            },
            invoiceZipCode: {
                required: "Wymagane",
            },
            invoiceCity: {
                required: "Wymagane",
            },
        },
        errorElement: 'span',
        focusInvalid: false,
        invalidHandler: function(form, validator) {
            if (!validator.numberOfInvalids())
                return;
            
            $('html, body').animate({
                scrollTop: $(validator.errorList[0].element).offset().top-100
            }, 500);
        },
        errorPlacement: function(error, element) {
            error.insertAfter(element).addClass('show');
        },
        highlight: function(element) {
            $(element).parents('.form-group').removeClass('valid').addClass('error');
          },
        unhighlight: function(element) {
            $(element).parents('.form-group').removeClass('error').addClass('valid');
        },
        submitHandler: function(form) {
            $(form).ajaxSubmit(buy_options_2);
        }
    });
        
    var buy_options_22 = {
        beforeSubmit: function(arr, $form, options) {
            $('.btn-submit-form2').html('Weryfikacja danych ...');
            
            $('#invoiceFirstname').val($('#firstname').val());
            $('#invoiceLastname').val($('#lastname').val());
        },
        success: function(responseText, statusText, xhr, $form) {
            if (responseText != "") {
                var response  = $.parseJSON(responseText);
                // console.log(response);

                if(response.message != 'OK'){
                    $('.btn-submit-form2').html('Kolejny krok: Podsumowanie i Płatność');
                } else {
                            
                    setTimeout(function() {
                        window.location.href = $($form).attr('action-next');
                    }, 500);                    
                }

            } else {
                $('.btn-submit-form2').html('Kolejny krok: Podsumowanie i Płatność');
            }
        },
        error: function(responseText, statusText, xhr, $form) {
            console.log(responseText);
            console.log(statusText);
            $('.btn-submit-form2').html('Kolejny krok: Podsumowanie i Płatność');
        }
    };


    $('#buy-form-22').validate({
        ignore: [],
        rules: {
            locationStreet: {
                required: true,
            },
            firstname: {
                required: true,
            },
            lastname: {
                required: true,
            },
            email: {
                required: true,
                email: true
            },
            phone: {
                required: true,
            },
            accept1: {
                required: true,
            },
            accept2: {
                required: true,
            },
            accept3: {
                required: false,
            },
    
            invoiceCompanyName: {
                required: function(element) {
                    return $("#invoiceNip").val() != "" && $("#invoiceBox").prop('checked');
                }
            },
            invoiceNip: {
                nip: {
                    //depends: "#invoiceNip:filled"
                    depends: function(element) { 
                        return $("#invoiceNip").val() != "" && $("#invoiceBox").prop('checked');
                    }
                },
                //required: "#invoiceCompanyName:filled"
                required: function(element) {
                    return $("#invoiceCompanyName").val() != "" && $("#invoiceBox").prop('checked');
                }
            },
            
            invoiceStreet: {
                required: function(element) {
                    return $("#invoiceBox").prop('checked');
                }
            },
            invoiceZipCode: {
                required: function(element) {
                    return $("#invoiceBox").prop('checked');
                }
            },
            invoiceCity: {
                required: function(element) {
                    return $("#invoiceBox").prop('checked');
                }
            },
        },
        messages: {
            locationStreet: {
                required: 'Jeśli Twoja posesja nie ma jeszcze numeru, podaj tylko nazwę ulicy lub nazwę miejscowości oraz uzupełnij pole "Uwagi do adresu" pod mapą',
            },
            firstname: {
                required: "Wymagane",
            },
            lastname: {
                required: "Wymagane",
            },
            email: {
                required: "Wymagane",
                email: "Zły format e-mail"
            },
            phone: {
                required: "Wymagane",
            },
            accept1: {
                required: "Wymagane",
            },
            accept2: {
                required: "Wymagane",
            },
            accept3: {
                required: "Wymagane",
            },
            invoiceFirstname: {
                required: "Wymagane",
            },
            invoiceLastname: {
                required: "Wymagane",
            },
            invoiceCompanyName: {
                required: "Wymagane",
            },
            invoiceNip: {
                required: "Wymagane",
            },
            invoiceStreet: {
                required: "Wymagane",
            },
            invoiceZipCode: {
                required: "Wymagane",
            },
            invoiceCity: {
                required: "Wymagane",
            },
        },
        errorElement: 'span',
        focusInvalid: false,
        invalidHandler: function(form, validator) {
            if (!validator.numberOfInvalids())
                return;
            
            $('html, body').animate({
                scrollTop: $(validator.errorList[0].element).offset().top-100
            }, 500);
        },
        errorPlacement: function(error, element) {
            error.insertAfter(element).addClass('show');
        },
        highlight: function(element) {
            $(element).parents('.form-group').removeClass('valid').addClass('error');
          },
        unhighlight: function(element) {
            $(element).parents('.form-group').removeClass('error').addClass('valid');
        },
        submitHandler: function(form) {
            $(form).ajaxSubmit(buy_options_22);
        }
    });
    
    // Summary Step Page 
    // Save order and open payment page
    $('#btn-accept-order').click(function(){
        var url = $(this).attr('base-path');

        var data = {
            save: true
        }

        $.ajax({
            type: 'POST',
            data: data,
            dataType: "json",
            url: url + 'ajax/saveCartOrder',
            success: function(response) {
                // console.log(response);
                if(response.message == 'OK'){
                    $('#order-hash').val(response.orderHash);
                    $('#new-payment-form').submit();
                }
            },
            error: function(response) {
                // console.log(response);
            }
        });
    });
    
    /*
    $('.f_form').submit(function(){
        console.log('submit payment');
        
        return true;
    });
    */
   
    /* WIDGET ************************************************************/
    var buy_options_2_widget = {
        beforeSubmit: function(arr, $form, options) {
            $('.btn-submit-form2').html('Zamawiam ...');
            
            $('#invoiceFirstname').val($('#firstname').val());
            $('#invoiceLastname').val($('#lastname').val());
        },
        success: function(responseText, statusText, xhr, $form) {
            if (responseText != "") {
                var response  = $.parseJSON(responseText);
                // console.log(response);

                if(response.message != 'OK'){
                    $('.btn-submit-form2').html('Zamawiam i płacę');
                } else {
                    $('#order-hash').val(response.orderHash);

                    setTimeout(function() {
                        window.top.location.href = "https://www.wcexpress.pl/widget-platnosc?hash="+response.orderHash;
                    }, 1000);
                }

            } else {
                $('.btn-submit-form2').html('Zamawiam i płacę');
            }
        },
        error: function(responseText, statusText, xhr, $form) {
            console.log(responseText);
            console.log(statusText);
            $('.btn-submit-form2').html('Zamawiam i płacę');
        }
    };

    $('#buy-form-2-widget').validate({
        ignore: [],
        rules: {
            firstname: {
                required: true,
            },
            lastname: {
                required: true,
            },
            email: {
                required: true,
                email: true
            },
            phone: {
                required: true,
            },
            accept1: {
                required: true,
            },
            accept2: {
                required: true,
            },
            accept3: {
                required: true,
            },
            invoiceStreet: {
                required: true,
            },
            invoiceZipCode: {
                required: true,
            },
            invoiceCity: {
                required: true,
            },
        },
        messages: {
            firstname: {
                required: "Wymagane",
            },
            lastname: {
                required: "Wymagane",
            },
            email: {
                required: "Wymagane",
                email: "Zły format e-mail"
            },
            phone: {
                required: "Wymagane",
            },
            accept1: {
                required: "Wymagane",
            },
            accept2: {
                required: "Wymagane",
            },
            accept3: {
                required: "Wymagane",
            },
            invoiceFirstname: {
                required: "Wymagane",
            },
            invoiceLastname: {
                required: "Wymagane",
            },
            invoiceCompanyName: {
                required: "Wymagane",
            },
            invoiceNip: {
                required: "Wymagane",
            },
            invoiceStreet: {
                required: "Wymagane",
            },
            invoiceZipCode: {
                required: "Wymagane",
            },
            invoiceCity: {
                required: "Wymagane",
            },
        },
        errorElement: 'span',
        focusInvalid: false,
        invalidHandler: function(form, validator) {
            if (!validator.numberOfInvalids())
                return;
            
            $('html, body').animate({
                scrollTop: $(validator.errorList[0].element).offset().top-100
            }, 500);
        },
        errorPlacement: function(error, element) {
            error.insertAfter(element).addClass('show');
        },
        highlight: function(element) {
            $(element).parents('.form-group').removeClass('valid').addClass('error');
          },
        unhighlight: function(element) {
            $(element).parents('.form-group').removeClass('error').addClass('valid');
        },
        submitHandler: function(form) {
            $(form).ajaxSubmit(buy_options_2_widget);
        }
    });
    
    $('#get-delivery-address').click(function(e){
        e.preventDefault();
        $('#invoiceStreet').val($('#deliveryStreet').html());
        $('#invoiceZipCode').val($('#deliveryZipCode').html());
        $('#invoiceCity').val($('#deliveryCity').html());
    });

if ($('#buy-progress-box').length > 0){
    var waypoint = new Waypoint({
        element: document.getElementById('buy-progress-box'),
        offset: '10%',
        handler: function(direction) {
            $('#buy-progress-box').toggleClass('fixed');
            
            /*
            if (direction === 'down') {
                $('#buy-progress-box').addClass('fixed');
            } else if (direction === 'up') {
                $('#buy-progress-box').removeClass('fixed');
            }
            */
        }
    });
}

if ($('#buy-progress-box-2').length > 0){
    var waypoint = new Waypoint({
        element: document.getElementById('buy-progress-box-2'),
        offset: '10%',
        handler: function(direction) {
            $('#buy-progress-box-2').toggleClass('fixed');
            
            /*
            if (direction === 'down') {
                $('#buy-progress-box-2').addClass('fixed');
            } else if (direction === 'up') {
                $('#buy-progress-box-2').removeClass('fixed');
            }
            */
        }
    });
}

if ($('#location-box').length > 0){
    var waypointP1 = new Waypoint({
        element: document.getElementById('location-box'),
        offset: '40%',
        handler: function(direction) {
            $('.progress-box ul li').removeClass('active');
            $('.progress-mobile ul li').removeClass('active');
            if(!$('#progress-location').hasClass('done')){
                $('#progress-location').addClass('active');
            }

            $('#progress-location-mobile').addClass('active');
            updateProgressMobile(25);
        }
    });
}
if ($('#service-box').length > 0){
    var waypointP2 = new Waypoint({
        element: document.getElementById('service-box'),
        offset: '40%',
        handler: function(direction) {
            $('.progress-box ul li').removeClass('active');
            $('.progress-mobile ul li').removeClass('active');
            if(!$('#progress-heart').hasClass('done')){
                $('#progress-heart').addClass('active');
            }

            $('#progress-heart-mobile').addClass('active');
            updateProgressMobile(50);
        }
    });
}
if ($('#insurance-box').length > 0){
    var waypointP3 = new Waypoint({
        element: document.getElementById('insurance-box'),
        offset: '40%',
        handler: function(direction) {
            $('.progress-box ul li').removeClass('active');
            $('.progress-mobile ul li').removeClass('active');
            if(!$('#progress-shield').hasClass('done')){
                $('#progress-shield').addClass('active');
            }

            $('#progress-shield-mobile').addClass('active');
            updateProgressMobile(75);
        }
    });
}
if ($('#calendar-box').length > 0){
    var waypointP4 = new Waypoint({
        element: document.getElementById('calendar-box'),
        offset: '40%',
        handler: function(direction) {
            $('.progress-box ul li').removeClass('active');
            $('.progress-mobile ul li').removeClass('active');
            if(!$('#progress-calendar').hasClass('done')){
                $('#progress-calendar').addClass('active');
            }

            $('#progress-calendar-mobile').addClass('active');
            updateProgressMobile(100);
        }
    });
}

function countOrderPrice(element){
    var vat = 0.08;
    var productId = $('#'+element).attr('productId');
    var price = parseFloat($('#'+element).attr('price'));
    var priceService = parseFloat($('#'+element).attr('priceService'));
    var priceDelivery = parseFloat($('#'+element).attr('priceDelivery'));
    var priceInsurance = parseFloat($('#'+element).attr('priceInsurance'));
    var priceOther = parseFloat($('#'+element).attr('priceOther'));
    var count = parseInt($('#'+element).find('input[name=count]').val());
    var optionInsurance = $('#'+element).find('input[name=optionInsurance]').prop('checked');
    var optionOther = $('#'+element).find('input[name=optionOther]').prop('checked');
    
    /*
    console.log(price);
    console.log(priceService);
    console.log(priceDelivery);
    console.log(priceInsurance);
    console.log(priceOther);
    console.log(count);
    console.log(optionInsurance);
    console.log(optionOther);
    */
    
    var total = (price  * 4 * count) + (priceService * count) + priceDelivery;
    
    if (optionInsurance) {
        total = total + (priceInsurance * count);
    } else {
        priceInsurance = 0;
    }
    
    if (optionOther) {
        total = total + (priceOther * count);
    } else {
        priceOther = 0;
    }
    
    var totalBrutto = total + (total * vat);
    
    total = total.toFixed(2);
    totalBrutto = totalBrutto.toFixed(2);
    
    $('#'+element).find('.price-value').html(totalBrutto.replace('.', ',') + ' pln');
    
    $('#productId').val(productId);
    $('#productCount').val(count);
    $('#price').val(price);
    $('#price-total').val(total);
    $('#price-service').val(priceService);
    $('#price-delivery').val(priceDelivery);
    $('#price-insurance').val(priceInsurance);
    $('#price-other').val(priceOther);
    $('#option-insurance').val(optionInsurance);
    $('#option-other').val(optionOther);
}

$('.order-results-items').on('click', '.btn-count', function(){
    var input = $(this).closest('.counting-box').find('input');
    var value = input.val();
    var increment = $(this).hasClass('inc');
    
    if (increment) {
        value++;
    } else {
        if (value > 1){
            value--;
        }
    }
    
    input.val(value);
    
    var orderElement = $(this).closest('.result-item').attr('id');
    countOrderPrice(orderElement);
});

$('.order-results-items').on('change', 'input[name=optionInsurance]', function(){
    var orderElement = $(this).closest('.result-item').attr('id');
    countOrderPrice(orderElement);
});

$('.order-results-items').on('change', 'input[name=optionOther]', function(){
    var orderElement = $(this).closest('.result-item').attr('id');
    countOrderPrice(orderElement);
});

$('.order-results-items').on('change', '.counting-box input', function(){
    var orderElement = $(this).closest('.result-item').attr('id');
    countOrderPrice(orderElement);
});

$('.order-results-items').on('click', '.btn-order-submit', function(e){
    //e.preventDefault();
    
    var orderElement = $(this).closest('.result-item').attr('id');
    countOrderPrice(orderElement);
});

}

 module.exports = {
    forms,
 };
